import { dateAndTime } from '@/constants/TimeFormats'
import { formatInTimeZone, toDate } from 'date-fns-tz'
export const localToUtc = (timestamp) => {
  return formatInTimeZone(timestamp, 'UTC', dateAndTime)
}

export const utcToLocal = (timestamp) => {
  // Assume the end_time is saved/fetched in UTC
  const parsedDate = toDate(timestamp, { timeZone: 'UTC' })
  // Convert to local tz
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
  return formatInTimeZone(parsedDate, tz, dateAndTime)
}

export default { localToUtc, utcToLocal }
